/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforinfo2Inputs */

const en_goodforinfo2 = /** @type {(inputs: Goodforinfo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests can say in the app what your place is good for. Once at least 5 people agree, it shows as a label on your page and helps in Search and Explore. Staff and new accounts do not count.`)
};

const de_goodforinfo2 = /** @type {(inputs: Goodforinfo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste können in der App angeben, wofür dein Ort gut ist. Stimmen mindestens 5 Personen zu, steht es als Label auf deiner Seite und hilft in Suche und Entdecken. Mitarbeitende und neue Konten zählen nicht.`)
};

/**
* | output |
* | --- |
* | "Guests can say in the app what your place is good for. Once at least 5 people agree, it shows as a label on your page and helps in Search and Explore. Staff ..." |
*
* @param {Goodforinfo2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforinfo2 = /** @type {((inputs?: Goodforinfo2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforinfo2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforinfo2(inputs)
	return de_goodforinfo2(inputs)
});
export { goodforinfo2 as "goodForInfo" }